const Common = {

    // BUTTON
    "add": "बनाएँ",
    "submit": "सहेजें",
    "apply": "लागू करें",
    "clear": "साफ़ करें",
    "cancel": "रद्द करें",
    "ok": "ठीक है",
    "save_next": "सहेजें और अगला",
    "close": "बंद करें",
    "login_signup": "लॉगिन / साइन अप",
    "login": "लॉगिन",
    "register": "रजिस्टर करें",
    "sign_up": "साइन अप",

    // PAGE HEADER
    "filter": "फ़िल्टर",

    // TOOLTIP
    "download": "डाउनलोड",
    "pdf": "PDF",
    "excel": "Excel",
    "edit": "संपादित करें",
    "delete": "हटाएं",

    // TOAST
    "success_add": "सफलतापूर्वक बनाया गया",
    "success_update": "सफलतापूर्वक संपादित किया गया",
    "wrong": "कुछ गलत हो गया",

    // SWEET ALERT
    "confirm_text": "क्या आप वाकई हटाना चाहते हैं?",
    "delete_text": "सफलतापूर्वक हटाया गया",

    // TABLE HEADER
    "table_no": "क्रमांक",
    "table_action": "क्रिया",

    // PAGINATION
    "page_size": "पृष्ठ आकार",
    "previous": "पिछला",
    "next": "अगला",

}

export default Common;